import { useContext } from 'react'

import { storesContext, StoresMapping } from 'vendor/contexts/store_public_vendor_context'

export const usePublicVendorStores = (): StoresMapping => useContext<StoresMapping>(storesContext)
